import { forwardRef } from "react";

import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import ChevronThinRightIcon from "@/icons/ChevronThinRightIcon";
import {
  rootCss,
  detailCss,
  iconCss,
  optionCss,
  titleCss,
} from "./AssignmentOption.style";

const propTypes = {
  assignmentData: PropTypes.object,
  onClick: PropTypes.func,
};

const AssignmentOption = forwardRef(({ assignmentData, onClick }, ref) => {
  const hasClassrooms = assignmentData.assignment_classrooms?.length > 0;
  return (
    <li css={rootCss} onClick={onClick} ref={ref}>
      <div css={optionCss}>
        <h2 css={titleCss}>
          <Button flavor={Button.flavors.incognito}>
            {assignmentData.title}
          </Button>
        </h2>
        <ul role="list" css={detailCss}>
          <li>Teacher: {assignmentData.created_by?.user?.display_name}</li>
          {hasClassrooms ? (
            <li>
              Class: {assignmentData.assignment_classrooms[0].classroom.name}
            </li>
          ) : null}
        </ul>
      </div>
      <span css={iconCss}>
        <ChevronThinRightIcon />
      </span>
    </li>
  );
});

AssignmentOption.propTypes = propTypes;

export default AssignmentOption;
